import {useNavigate} from 'react-router-dom'

const useNavigation = () => {
    const navigate = useNavigate()

    const goLogin = () => {
        return navigate('/login')
    }

    const goMain = () => {
        return navigate('/')
    }

    const goUserDetail = id => {
        return navigate(`/user?id=${id}`)
    }

    const goPostList = () => {
        return navigate('/post')
    }

    const goPostDetail = id => {
        return navigate(`/post/detail?id=${id}`)
    }

    const goPostCreate = () => {
        return navigate('/post/create')
    }

    const goCommentList = () => {
        return navigate('/comment')
    }

    const goCommentDetail = id => {
        return navigate(`/comment/detail?id=${id}`)
    }

    const goLeagueList = () => {
        return navigate('/league')
    }

    const goLeagueCreate = () => {
        return navigate('/league/create')
    }

    const goLeagueDetail = id => {
        return navigate(`/league/detail?id=${id}`)
    }

    const goEvent = () => {
        return navigate('/event')
    }

    const goEventCreate = () => {
        return navigate('/event/create')
    }

    const goEventDetail = id => {
        return navigate(`/event/detail?id=${id}`)
    }

    const goAdvertisement = () => {
        return navigate(`/advertisement`)
    }

    const goAdvertisementCreate = () => {
        return navigate(`/advertisement/create`)
    }

    const goAdvertisementDetail = id => {
        return navigate(`/advertisement/detail?id=${id}`)
    }

    const goLeader = () => {
        return navigate(`/leader`)
    }

    const goLeaderDetail = id => {
        return navigate(`/leader/detail?id=${id}`)
    }

    const goCopier = () => {
        return navigate(`/copier`)
    }

    const goCopierDetail = id => {
        return navigate(`/copier/detail?id=${id}`)
    }

    const goCampaign = () => {
        return navigate(`/campaign`)
    }

    const goCampaignCreate = () => {
        return navigate(`/campaign/create`)
    }

    const goCampaignDetail = id => {
        return navigate(`/campaign/detail?id=${id}`)
    }

    const goKeyDetail = id => {
        return navigate(`/api/detail?id=${id}`)
    }

    const goKeyProbe = id => {
        return navigate(`/api/probe?id=${id}`)
    }

    const goAnnounceDetail = id => {
        return navigate(`/announce/detail?id=${id}`)
    }

    const goAnnounceCreate = () => {
        return navigate(`/announce/create`)
    }

    const goWithdrawDetail = (id, status?: any) => {
        return navigate(`/withdraw/detail?id=${id}${status ? `&status=${status}` : ''}`)
    }

    const goBanner = () => {
        return navigate(`/banner`)
    }

    const goBannerCreate = () => {
        return navigate(`/banner/create`)
    }

    const goBannerDetail = id => {
        return navigate(`/banner/detail?id=${id}`)
    }

    const goProHistory = () => {
        return navigate(`/pro/history`)
    }

    const goAbnormalDatail = id => {
        return navigate(`/abnormal/detail?id=${id}`)
    }

    const goFloatingMessage = () => {
        return navigate(`/floating`)
    }

    const goFloatingMessageCreate = () => {
        return navigate(`/floating/create`)
    }

    const goFloatingMessageDetail = id => {
        return navigate(`/floating/detail?id=${id}`)
    }

    const goPayback = () => {
        return navigate(`/referral`)
    }

    const goPaybackDetail = exchange => {
        return navigate(`/referral/detail?exchange=${exchange}`)
    }

    const goBadge = () => {
        return navigate(`/badge`)
    }

    const goBadgeCreate = () => {
        return navigate(`/badge/create`)
    }

    const goBadgeDetail = id => {
        return navigate(`/badge/detail?id=${id}`)
    }

    const goUserBadge = () => {
        return navigate(`/badge/user`)
    }

    return {
        goLogin,
        goMain,
        goUserDetail,
        goPostList,
        goPostDetail,
        goPostCreate,
        goCommentList,
        goCommentDetail,
        goLeagueList,
        goLeagueDetail,
        goLeagueCreate,
        goEvent,
        goEventCreate,
        goEventDetail,
        goAdvertisement,
        goAdvertisementCreate,
        goAdvertisementDetail,
        goAbnormalDatail,
        goLeader,
        goLeaderDetail,
        goCopier,
        goCopierDetail,
        goCampaign,
        goCampaignCreate,
        goCampaignDetail,
        goKeyDetail,
        goKeyProbe,
        goAnnounceDetail,
        goAnnounceCreate,
        goWithdrawDetail,
        goBanner,
        goBannerCreate,
        goBannerDetail,
        goProHistory,
        goFloatingMessage,
        goFloatingMessageCreate,
        goFloatingMessageDetail,
        goPayback,
        goPaybackDetail,
        goBadge,
        goBadgeCreate,
        goBadgeDetail,
        goUserBadge,
    }
}

export default useNavigation
